import { useMemo } from 'react';
import { InsurerIntegrationProvider } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

export const createInsurerIntegrationValidator = (provider: InsurerIntegrationProvider, isUpdate = false) => {
    switch (provider) {
        case InsurerIntegrationProvider.Email: {
            return validators.compose(validators.requiredString('email'), validators.validEmail('email'));
        }

        case InsurerIntegrationProvider.Eazy: {
            return validators.compose(
                validators.requiredString('username'),
                validators.requiredString('password'),
                validators.requiredString('apiUrl')
            );
        }

        default:
            throw new Error(`invalid Insurer integration provider: ${provider}`);
    }
};

const useInsurerIntegrationFormValidation = (provider: InsurerIntegrationProvider) => {
    const validator = useMemo(() => createInsurerIntegrationValidator(provider, true), [provider]);

    return useValidator(validator);
};

export default useInsurerIntegrationFormValidation;
